import React, { useContext, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {
  Button,
  Layout,
  MobileTabBar,
  Footer,
  Accordion,
  Input,
  Select,
  SelectFile,
} from '../../components';

import './support.less';
import '../Profile/profile-general.less';
import '../../components/Card/card.less';

import RightChevronIcon from '../../assests/icons/right-chevron.icon';
import { Tabs, Modal, Form } from 'antd';
import { DimensionsContext } from '../../context/dimensions.context';
import ContactUs from 'components/ContactUs/contactus';

const { TabPane } = Tabs;

const AccordionList = [
  {
    header: 'Mesaj Üssü hesabıma nasıl kullanıcı ekleyebilirim?    ',
    content:
      'Profil bilgileri – Yetki işlemleri başlığı altından istediğiniz numaraya yetkilendirme yapabilirsiniz.     ​',
  },
  {
    header: 'Numara değişikliği, devir, faturasız hata geçiş, numara taşıma, borç nedeniyle hattın kapanması, kendi isteğiyle hat kapama veya fatura dönem değişikliğinde aboneliğim devam eder mi?    ',
    content:
      "Hayır, Mesaj Üssü aboneliğiniz sona erer.      ",
  },
  {
    header: 'Paket almadan gönderim yapmayı deneyebilir miyim?    ',
    content:
      'Mesaj Üssü’ne üye olduktan sonra hesabınıza ücretsiz 50 kredi tanımlanır. Ünvan onay işleminizden sonra 50 kredinizi kullanarak SMS göndermeyi deneyebilirsiniz.      ',
  },
  {
    header: 'Kredilerimin geçerlilik süresi ne kadar?    ',
    content:
      '12 ay içerisinde kullanılmayan SMS kredileriniz silinecektir. 12 ay içinde yeni bir Mesaj Üssü Paketi satın almanız durumunda, kalan tüm kredilerinizin geçerlilik süresi 12 ay sonrasına kadar uzayacaktır.      ',
  },
  {
    header: 'Kullanım bilgileri kaç aya kadar raporlanabiliyor?    ',
    content:
      'Kullanım bilgileri kaç aya kadar raporlanabiliyor?      ',
  }
];

const SupportAccounts = () => {
  const [modalSendUs, setModalSendUs] = useState(false);
  const { isTabletBig } = useContext(DimensionsContext);
  const [form] = Form.useForm();

  let history = useHistory();

  function onChangeTabs(key) {
    if (key == 1) {
      history.push('./CreditPurchaseHelp');
    } else if (key == 2) {
      history.push('./MessagesHelp');
    } else if (key == 3) {
      history.push('./ReportsHelp');
    } else if (key == 4) {
      history.push('./AccountsHelp');
    }
  }

  return (
    <Layout>
      <div className="profile-page support">
        <div className="container">
          <div className="profile-page__title">
            <h1 className="section__title">Yardım</h1>
          </div>
          <div className="content-wrapper">
            {isTabletBig ? (
              <div className="profile-page__menu sub-groups">
                <h2 className="box__title">Yardım Konuları</h2>
                <ul>
                  <li>
                    <NavLink
                      to="./CreditPurchaseHelp"
                      classname="active"
                      activeClassName="active"
                    >
                      <span>Kredi Satın Alımı</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="./MessagesHelp"
                      activeClassName="active"
                    >
                      <span>Gönderim İşlemleri</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="./ReportsHelp" activeClassName="active">
                      <span>Raporlar</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="./AccountsHelp" activeClassName="active">
                      <span>Şirket ve Hesaplar</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                </ul>
                <div className="write-us">
                  <span>Sorularınıza yanıt alamadınız mı?</span>
                  <Button
                    type="primary"
                    shape="round"
                    onClick={() => setModalSendUs(true)}
                  >
                    Bize Yazın
                  </Button>
                </div>
              </div>
            ) : (
              <Tabs
                defaultActiveKey="1"
                onChange={onChangeTabs}
                renderTabBar={(props, Item) => {
                  return <MobileTabBar props={props} item={Item} />;
                }}
              >
                <TabPane tab="Kredi Satın Alımı" key="1"></TabPane>
                <TabPane tab="Gönderim İşlemleri" key="2"></TabPane>
                <TabPane tab="Raporlar" key="3"></TabPane>
                <TabPane tab="Şirket ve Hesaplar" key="4"></TabPane>
              </Tabs>
            )}
            <div className="profile-page__content">
              <Accordion list={AccordionList} />
            </div>
            {!isTabletBig ? (
              <div className="write-us">
                <span>Sorularınıza yanıt alamadınız mı?</span>
                <Button
                  type="primary"
                  shape="round"
                  onClick={() => setModalSendUs(true)}
                >
                  Bize Yazın
                </Button>
              </div>
            ) : null}
          </div>
          {modalSendUs &&  (
      <ContactUs visible={modalSendUs} onClose={e=> setModalSendUs(false)}  onOpen={e=> setModalSendUs(true)}  />)}
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default SupportAccounts;
